import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { connect } from 'shalala';

import { useStore } from '../../store';
import Storage from '../../support/Storage';
import NoticeHighlighter from '../../shared/notice/NoticeHighlighter';

const EmisoresSoonToExpireHighlighter = (props) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    showNotice();
  }, []);

  useEffect(() => {
    if (show) {
      expires();
    }
  }, [show]); // eslint-disable-line

  const showNotice = async () => {
    const { date } = (await Storage.get('emisores.expire')) || {};

    if (!date) {
      setShow(true);
    } else {
      setShow(moment(date) <= moment());
    }
  };

  const expires = () => {
    const { filters = {} } = props.expires;

    const meta = {
      status: 'expire',
    };

    setTimeout(() => {
      props.expiresActions.expires({
        ...filters,
        ...meta,
      });
    }, 5000);
  };

  const rfc_all = () => {
    const { data = [] } = props.expires;

    return data.map((item) => item.rfc);
  };

  const count = rfc_all().length;

  const handleIsClose = async () => {
    await Storage.put('emisores.expire', {
      date: moment().add(1, 'days').toString(),
    });
  };

  const metadata = {
    close: true,
    variant: 'danger',
    nombre_comercial:
      count > 1
        ? 'Los siguientes RFCs: ' + rfc_all().join(', ').toString() + ' estan por caducar. '
        : 'El siguientes RFC' + rfc_all().join(', ').toString() + 'esta por caducar. ',
    notice: ' Es importante generar los nuevos certificados y actualizar la plataforma.',
    isClose: handleIsClose,
  };

  if (props.expires.data.length === 0) {
    return <></>;
  }

  return <NoticeHighlighter {...metadata} />;
};

const mapState = (store) => {
  return { expires: store.app.emisores.expires };
};

const mapActions = (actions) => {
  return { expiresActions: actions.app.emisores.expires };
};

export default connect(useStore, mapState, mapActions)(EmisoresSoonToExpireHighlighter);
